import * as React from "react";
import {ReactNode} from "react";
import Grid from "@mui/material/Grid";

interface ChatInfoLineProps {
    icon: ReactNode;
    text?: string,
    children?: ReactNode
}

export default function ChatInfoLine(props: ChatInfoLineProps) {
    return <Grid container direction={"column"}>
        <Grid item className={'info-line'}>
            <Grid container alignItems={"center"} spacing={2} wrap={"nowrap"} style={{cursor: "pointer"}}>
                <Grid item display={"inherit"}>
                    {props.icon}
                </Grid>
                {props.text &&
                    <Grid item>
                        {props.text}
                    </Grid>
                }
                {props.children &&
                    <Grid item>
                        {props.children}
                    </Grid>
                }
            </Grid>
        </Grid>
    </Grid>;
}